module.exports = __webpack_public_path__ + "img/Office2.13cf3b0f.png";